<script>
import { sleep } from '@/util'
import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  props: {
    loading: {
      type: Boolean,
    },
    offer: {
      type: Object,
    },

    /**
     * {
     *    loanType: 'woori_crowd',
     *    repaymentPeriodInDays: 180,
     *  }
     */
    options: {
      type: Object,
      required: true,
    },
  },
  watch: {
    offer: {
      deep: true,
      immediate: true,
      async handler(v) {
        try {
          this.$emit('update:loading', true)
          if (!v || v?.status === 'in_progress') {
            const { data } = await defaultApi.getLoansOffersCurrent(this.options)
            if (data.status === 'in_progress') {
              await sleep(5000)
            }
            console.log('GetOffer API Response:', data)
            this.$emit('update:offer', data)
            return
          }
          this.$emit('completed', v)
          this.$emit('update:loading', false)
        } catch (e) {
          // 에러가 난 경우 offer를 임의적으로 올려보내서 재요청을 하게끔 한다.
          await sleep(5000)
          this.$emit('update:offer', {
            amount: 0,
            status: 'in_progress',
          })
        }
      },
    },
  },
  render() {
    return this.$scopedSlots.default({
      offer: this.offer,
      amount: this.offer?.amount,
      loading: this.loading,
    })
  },
}
</script>

<style lang="scss" scoped></style>
